import { createSlice } from "@reduxjs/toolkit";

export const communityChatV1 = createSlice({
  name: "community_chat_v1",
  initialState: {
    value: {
      status: false,
      communities: { isSet: false, data: [] },
      joinedCommunities: { isSet: false, data: [] },
      availableCommunities: { isSet: false, data: [] },
      selectedCommunity: {
        isSet: false,
        _id: "",
        profileImage: "",
        name: "",
        messages: [],
      },
    },
  },
  reducers: {
    updateCommunities: (state, action) => {
      state.value.status = true;
      state.value.communities = { isSet: true, data: action.payload };
    },
    updateJoinedCommunities: (state, action) => {
      state.value.joinedCommunities = { isSet: true, data: action.payload };
    },
    updateAvailableCommunities: (state, action) => {
      state.value.availableCommunities = { isSet: true, data: action.payload };
    },
    addToAvailableCommunities: (state, action) => {
      state.value.availableCommunities = {
        isSet: true,
        data: [...state.value.availableCommunities?.data, action.payload],
      };
    },
    updateSelectedCommunity: (state, action) => {
      const deepCloned = [...state.value.joinedCommunities?.data];
      const { _id, name, profileImage, type, pinnedMessage, messages } =
        action.payload;
      state.value.selectedCommunity = {
        isSet: true,
        _id: _id,
        profileImage: profileImage,
        name: name,
        type: type,
        pinnedMessage: pinnedMessage,
        messages: messages ? messages : [],
      };

      const currentIndex = deepCloned.findIndex((v) => v._id === _id);
      const currentData = deepCloned[currentIndex];
      deepCloned.splice(currentIndex, 1, {
        _id: _id,
        name: name,
        profileImage: profileImage,
        members: currentData?.members,
        messages: currentData?.messages,
        statu: type,
      });
      // state.value.joinedCommunities.data = deepCloned;
    },
    updateCommunityChatMessages: (state, action) => {
      state.value.selectedCommunity.messages = [
        ...state.value.selectedCommunity.messages,
        action.payload.message,
      ];
    },
    // dagogo addtion aug 5th - replace an optimistic message with the server moderation result.
    updateACommunityChatMessageStatus: (state, action) => {
      const { clientMessageId, message } = action.payload;
      const messageIndex = state.value.selectedCommunity.messages.findIndex(
        (communityMessage) =>
          communityMessage.clientMessageId === clientMessageId
      );

      if (messageIndex === -1) return;

      const optimisticMessage =
        state.value.selectedCommunity.messages[messageIndex];

      state.value.selectedCommunity.messages[messageIndex] = {
        ...optimisticMessage,
        ...message,
        // dagogo addtion aug 5th - retain the populated sender when the API returns only its ID.
        sender:
          message?.sender && typeof message.sender === "object"
            ? message.sender
            : optimisticMessage.sender,
        clientMessageId,
      };
    },
    removeMessage: (state, action) => {
      const { index } = action.payload;
      const deepCloned = [...state.value.selectedCommunity.messages];
      deepCloned.splice(index, 1, { ...deepCloned[index], deletedAt: "now" });
      // deletedAt = "now";
      state.value.selectedCommunity.messages = deepCloned;
    },
    joinedNewCommnity: (state, action) => {
      const deepCloned = [...state.value.availableCommunities.data];
      const { _id } = action?.payload?.joinedCommunityData;
      state.value.joinedCommunities.data = [
        ...state.value.joinedCommunities.data,
        action.payload.joinedCommunityData,
      ];
      const currentIndex = deepCloned.findIndex((v) => v._id === _id);
      deepCloned.splice(currentIndex, 1);
      state.value.availableCommunities.data = deepCloned;
    },
    leaveCommunity: (state, action) => {
      state.value.availableCommunities.data = [
        ...state.value.availableCommunities.data,
        action.payload.leftCommunityData,
      ];
      try {
        state.value.joinedCommunities.data.forEach((item, index) => {
          if (item?._id === action.payload.leftCommunityData?._id) {
            state.value.joinedCommunities.data.splice(index, 1);
          }
        });
      } catch (error) {}
    },
    deleteCommunity: (state, action) => {
      try {
        state.value.joinedCommunities.data.forEach((item, index) => {
          if (item?._id === action.payload?._id) {
            state.value.joinedCommunities.data.splice(index, 1);
          }
        });
      } catch (error) {}
    },
    resetChat: (state, action) => {
      state.value = {
        status: false,
        communities: { isSet: false, data: [] },
        joinedCommunities: { isSet: false, data: [] },
        availableCommunities: { isSet: false, data: [] },
        selectedCommunity: {
          isSet: false,
          _id: "",
          profileImage: "",
          name: "",
          messages: [],
        },
      };
    },
  },
});

export const {
  updateCommunities,
  updateJoinedCommunities,
  updateAvailableCommunities,
  addToAvailableCommunities,
  updateSelectedCommunity,
  updateCommunityChatMessages,
  // dagogo addtion aug 5th - export the optimistic-message reconciliation action.
  updateACommunityChatMessageStatus,
  removeMessage,
  joinedNewCommnity,
  leaveCommunity,
  deleteCommunity,
  resetChat,
} = communityChatV1.actions;

export default communityChatV1.reducer;
